import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-capitalize" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-6 col-md-6 col-12 mb-5" }
const _hoisted_5 = { class: "row mt-10" }
const _hoisted_6 = { class: "col-12 d-flex justify-content-end" }
const _hoisted_7 = ["data-kt-indicator", "onClick"]
const _hoisted_8 = { class: "indicator-label" }
const _hoisted_9 = { class: "indicator-progress" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormField = _resolveComponent("FormField")!
  const _component_FormIconInput = _resolveComponent("FormIconInput")!
  const _component_Form = _resolveComponent("Form")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    modelValue: _ctx.dialog,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dialog) = $event))
  }, {
    header: _withCtx(() => [
      _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.title), 1)
    ]),
    body: _withCtx(() => [
      _createVNode(_component_Form, {
        "initial-values": _ctx.formInitialValue,
        "validation-schema": _ctx.formSchema,
        ref: "modalForm"
      }, {
        default: _withCtx(({ handleSubmit, values }) => [
          _createElementVNode("form", {
            novalidate: "novalidate",
            onSubmit: _withModifiers(($event: any) => (handleSubmit(values, _ctx.handleSubmitForm)), ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_FormField, {
                required: true,
                value: values.code,
                formControlClass: "form-control",
                label: "Code",
                showLabel: true,
                name: "code",
                placeholder: "Code",
                type: "text",
                containerClass: "col-lg-6 col-md-6 col-12 mb-5",
                style: {"margin-bottom":"10px !important"},
                disabled: ""
              }, null, 8, ["value"]),
              _createVNode(_component_FormField, {
                required: true,
                value: values.title,
                formControlClass: "form-control",
                label: "Title",
                showLabel: true,
                name: "title",
                placeholder: "Title",
                type: "text",
                containerClass: "col-lg-6 col-md-6 col-12 mb-5",
                style: {"margin-bottom":"10px !important"}
              }, null, 8, ["value"]),
              _createVNode(_component_FormField, {
                required: true,
                value: values.subtitle,
                formControlClass: "form-control",
                label: "Sub-title",
                showLabel: true,
                name: "subtitle",
                placeholder: "Sub-title",
                type: "text",
                containerClass: "col-lg-6 col-md-6 col-12 mb-5",
                style: {"margin-bottom":"10px !important"}
              }, null, 8, ["value"]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_FormIconInput, {
                  "show-label": true,
                  required: true,
                  label: "Icon",
                  placeholder: "Select an icon",
                  modelValue: values.icon,
                  "onUpdate:modelValue": ($event: any) => ((values.icon) = $event),
                  name: "icon"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-new-design-primary align-self-center w-lg-auto w-100 w-md-auto w-sm-100",
                  "data-kt-indicator": _ctx.loading ? 'on' : null,
                  onClick: ($event: any) => (_ctx.handleSubmitForm(values))
                }, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.btnText), 1),
                  _createElementVNode("span", _hoisted_9, [
                    _createTextVNode(_toDisplayString(_ctx.loadingText) + " ", 1),
                    _hoisted_10
                  ])
                ], 8, _hoisted_7)
              ])
            ])
          ], 40, _hoisted_2)
        ]),
        _: 1
      }, 8, ["initial-values", "validation-schema"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}